import React from 'react';

import {safelySetInnerHTML} from '@udemy/shared-utils';

import styles from './description.module.less';

export type QuestionAnswer = {
    question: string;
    answerHTML: string;
};

export const QuestionAnswerItem = ({
    questionAnswer,
    index,
    handleContainerClick,
}: {
    questionAnswer: QuestionAnswer;
    index: number;
    handleContainerClick: (e: React.MouseEvent<HTMLElement>) => void;
}) => {
    return (
        <div className={styles['text-container']} key={index}>
            <h2 className={'ud-heading-lg'}>{questionAnswer.question}</h2>
            <div
                onClick={handleContainerClick}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        handleContainerClick(e as unknown as React.MouseEvent<HTMLElement>);
                    }
                }}
                role="button"
                tabIndex={0}
                className={'ud-text-md'}
                {...safelySetInnerHTML({
                    descriptionOfCaller: `voucher-landing-page:question-answer-${index}`,
                    html: questionAnswer.answerHTML,
                    domPurifyConfig: {
                        ADD_TAGS: ['use'],
                        ADD_ATTR: ['xlink:href', 'target'],
                    },
                })}
            />
        </div>
    );
};
